<template>
  <div class="o-input">
    <label class="o-input__label">{{ klas.title }}</label>
  </div>
  <div class="o-input">
    <label class="o-input__label">Ouder</label>
    <div class="o-input__controls">
      <p>{{ contact.parent.givenName }} {{ contact.parent.familyName }} - {{ contact.parent.email }}</p>
    </div>
  </div>
  <div class="o-input">
    <label class="o-input__label">Leerling</label>
    <div class="o-input__controls">
      <p>{{ contact.student.givenName }} {{ contact.student.familyName }} - {{ contact.student.email }}</p>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed } from "vue";

export default {
  setup() {
    const store = useStore();

    return {
      klas: computed(() => store.getters["orders/klas"]),
      contact: computed(() => store.getters["orders/contact"]),
    };
  },
};
</script>
